import { _T, language } from '../../../../../include/appI18n';
import { appUrl, pluralizeAutoSplit } from '../../../../../include/utils';
export const capitalFlightAssetBaseUrl = appUrl('/Content/capital/assets/');
export const capitalFlightRetryLabel = (language === null || language === void 0 ? void 0 : language.toLowerCase().startsWith('en')) ? 'Try again' : 'Повторить';
export const capitalFlightLabels = {
    forward: _T.FLIGHT_SEARCH_ADDITIONAL_FILTER_DIRECTION_FORWARD_2,
    return: _T.FLIGHT_SEARCH_ADDITIONAL_FILTER_DIRECTION_RETURN,
    flight: _T.COMMON_FLIGHT_PLANE,
    duration: _T.FLIGHT_SEARCH_ADDITIONAL_FILTER_FLIGHT_DURATION,
    transfer: _T.FLIGHT_SEARCH_TRANSFER,
    direct: _T.FLIGHT_SEARCH_ADDITIONAL_FILTER_WITHOUT_TRANSFERS,
    handBaggage: _T.FLIGHT_SEARCH_HAND_BAGGAGE,
    baggage: _T.FLIGHT_SEARCH_BAGGAGE,
    noHandBaggage: _T.FLIGHT_SEARCH_WITHOUT_HAND_BAGGAGE,
    noBaggage: _T.FLIGHT_SEARCH_WITHOUT_BAGGAGE,
    refundable: _T.FLIGHT_SEARCH_REFUNDABLE_LABEL,
    exchangeable: _T.FLIGHT_SEARCH_EXCHANGEABLE_LABEL,
    seatsLeft: _T.FLIGHT_SEARCH_PLACES_LEFT,
    details: _T.FLIGHT_SEARCH_MORE_DETAILS,
    yes: _T.COMMON_YES,
    no: _T.COMMON_NO,
    weightUnit: (language === null || language === void 0 ? void 0 : language.toLowerCase().startsWith('en')) ? 'kg' : 'кг',
    formatDuration: minutes => {
        const hours = Math.floor(minutes / 60);
        const remainder = minutes % 60;
        return `${hours} ${pluralizeAutoSplit(hours, _T.COMMON_HOURS_SHORT)} ${remainder} ${pluralizeAutoSplit(remainder, _T.COMMON_MINUTES_SHORT)}`;
    },
};
